import React from "react";

export const PremiumCrow = () => (
  <svg width="14" viewBox="0 0 7.148 6.232">
    <g id="royal-crown" transform="translate(0 0)">
      <path
        id="royal-crown-1"
        d="M5.376.4a.4.4,0,0,0-.4-.4H.4A.4.4,0,1,0,.4.794H4.977A.4.4,0,0,0,5.376.4Z"
        transform="translate(0.886 5.438)"
        fill="#fff"
      />
      <path
        id="royal-crown-2"
        data-name="Path"
        d="M.476,2.584H.5l.635,2.3H6.018l.635-2.3h.019A.477.477,0,1,0,6.2,2.107a.466.466,0,0,0,.023.147l-1.148.673L3.837.875a.476.476,0,1,0-.526,0L2.078,2.927.93,2.254a.487.487,0,0,0,.023-.147.476.476,0,1,0-.477.477Z"
        fill="#fff"
      />
    </g>
  </svg>
);

export const Loading = () => (
  <svg
    width="20px"
    height="20px"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <circle
      cx="50"
      cy="50"
      fill="none"
      stroke="#B5B5B5"
      strokeWidth="10"
      r="35"
      strokeDasharray="164.93361431346415 56.97787143782138"
      transform="rotate(215.545 50 50)"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        calcMode="linear"
        values="0 50 50;360 50 50"
        keyTimes="0;1"
        dur="1s"
        begin="0s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);
